import { api } from "./client";

export interface MountCatalogEntry {
  code: string;
  name: string;
  rarity: string;
  power: number;
  armor: number;
  endurance: number;
  training_cap_bonus: number;
  max_training_level: number;
}

export interface PlayerMountView {
  mount_code: string;
  training_level: number;
  training_xp: number;
  xp_to_next: number;
  effective_max_level: number;
  power: number;
  armor: number;
  endurance: number;
  owned: boolean;
}

export interface MountTotals {
  power: number;
  armor: number;
  endurance: number;
  global_training_cap: number;
}

export interface MountsState {
  unlocked: boolean;
  unlock_level: number;
  catalog: MountCatalogEntry[];
  mounts: PlayerMountView[];
  totals: MountTotals;
  training_stones: number;
}

export interface MountTrainResult {
  ok: boolean;
  message: string;
  mount: PlayerMountView;
  training_stones: number;
  totals: MountTotals;
  levels_gained: number;
}

export const mountsApi = {
  getState: () => api.get<MountsState>("/mounts/state"),
  train: (mount_code: string, stones = 1) =>
    api.post<MountTrainResult>("/mounts/train", { mount_code, stones }),
};
